function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
export const TwitterLogoFilledIcon = /*#__PURE__*/forwardRef(({
  className,
  style,
  ariaLabel,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  ref: ref,
  className: className,
  "aria-label": ariaLabel || "twitter logo, logo, twitter filled",
  style: style,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.59875 17.5C13.517 17.5 17.301 11.7286 17.301 6.72358C17.301 6.55967 17.301 6.3965 17.29 6.234C18.0269 5.69701 18.6623 5.03316 19.1666 4.2735C18.4805 4.57966 17.7522 4.78056 17.0062 4.86942C17.7913 4.39625 18.3792 3.65142 18.6598 2.7745C17.9222 3.21538 17.1143 3.52634 16.2714 3.69383C15.5602 2.93233 14.5669 2.5 13.5288 2.5C11.4633 2.5 9.76383 4.21133 9.76383 6.291C9.76383 6.5795 9.79659 6.86717 9.86134 7.14817C6.8385 6.99567 4.01825 5.55592 2.10925 3.191C1.1165 4.91183 1.63017 7.14183 3.27375 8.24692C2.67478 8.22894 2.08906 8.06628 1.56659 7.77283V7.82083C1.56709 9.61692 2.83584 11.178 4.58425 11.5336C4.03068 11.6856 3.44949 11.7079 2.88592 11.5986C3.37742 13.1376 4.79475 14.1985 6.4 14.2288C5.06834 15.2827 3.42234 15.8551 1.72867 15.8533C1.42938 15.8528 1.13039 15.8345 0.833252 15.7987C2.55089 16.9094 4.55328 17.4992 6.59875 17.4971",
  fill: "currentColor"
})));
export default TwitterLogoFilledIcon;